/* 
Displays all available stake withdrawals (based on unbonding lock state)
*/
import { Stack, Text } from "@mantine/core";
import WithdrawStakeButton from "./actions/WithdrawStakeButton";

export default function WithdrawStake(props) {
  if (!props.locks) {
    return (
      <Stack spacing={24}>
        <Text size="xl" fw={700}>
          Retrieving stake withdrawals in progress
        </Text>
      </Stack>
    );
  }

  let openLocks = [];
  for (const thisLock of props.locks) {
    if (thisLock.round > 0) {
      openLocks.push(thisLock);
    }
  }
  if (!openLocks.length) {
    return (
      <Stack spacing={24}>
        <Text size="xl" fw={700}>
          No pending withdrawals found
        </Text>
      </Stack>
    );
  } else {
    return (
      <Stack spacing={24}>
        {openLocks.map((item, idx) => {
            return (
              <WithdrawStakeButton
                key={"lock-" + idx}
                connectedWallet={props.connectedWallet}
                setErr={props.setErr}
                lock={item}
                thisRound={props.thisRound}
                refreshWallet={props.refreshWallet}
              />
            );
        })}
      </Stack>
    );
  }
}
